import React from 'react'
import PropTypes from 'prop-types'
import { CRUDShow } from '../CRUD'

const IcmsShow = (props) => {
  if (props.icms) {
    return (
      <CRUDShow
        title={props.icms.aliquota}
        icon='percent'
        onEditResource={() => props.onEditResource(props.icms.id)}
        onDeleteResource={() => props.onDeleteResource(props.icms.id)}>
        <ul>
          <li>UF: {props.icms.uf.nome}</li>
          <li>Classe de Consumo: {props.icms.classe_consumo.nome}</li>
          <li>Alíquota: {props.icms.aliquota}</li>
        </ul>
      </CRUDShow>
    )
  }

  return (null)
}

IcmsShow.propTypes = {
  icms: PropTypes.object,
  onEditResource: PropTypes.func,
  onDeleteResource: PropTypes.func,
}

export default IcmsShow
